<template>
  <div
    class="t-content-figure overflow-hidden relative z-0"
    :class="[
      classes,
      {
        't-content-figure--mobileFigureDown': mobileFigureDown,
        't-content-figure--desktopFigureRigth': desktopFigureRigth,
        't-content-figure--desktopItemsCenter': desktopItemsCenter,
      },
    ]"
  >
    <div data-test-id="t-content-figure__slotTitle" class="relative z-10">
      <!-- SLOT TITLE -->
      <slot name="title" />
    </div>

    <div
      class="flex lg:grid lg:grid-cols-2 lg:gap-8 relative"
      :class="{
        'lg:items-center': desktopItemsCenter,
        'flex-col-reverse': mobileFigureDown,
        'flex-col': !mobileFigureDown,
      }"
    >
      <div
        data-test-id="t-content-figure__slotFigure"
        class="z-10"
        :class="{
          'lg:row-start-1 lg:col-start-2': desktopFigureRigth,
          'mb-8 lg:mb-0': !mobileFigureDown,
        }"
      >
        <!-- SLOT FIGURE -->
        <slot name="figure" />
      </div>

      <div
        data-test-id="t-content-figure__slotContent"
        class="z-10"
        :class="{
          'mb-8 lg:mb-0': mobileFigureDown,
          'lg:row-start-1 lg:col-start-2': !desktopFigureRigth,
        }"
      >
        <!-- SLOT CONTENT -->
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  classes?: string
  mobileFigureDown?: boolean
  desktopFigureRigth?: boolean
  desktopItemsCenter?: boolean
}

withDefaults(defineProps<Props>(), {
  classes: 'py-12 lg:py-16',
  mobileFigureDown: false,
  desktopFigureRigth: false,
  DesktopItemsCente: false,
})
</script>
